import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'


const _hoisted_1 = { class: "bg-white" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "rounded-r bg-gray-lp-700 text-black-lp-300 text-center border-l border-gray-lp-400 outline-none items-center py-2.5 xxl:py-2.5 text-12px xxl:text-14px px-2" }, " cm ", -1)
const _hoisted_3 = { class: "text-red-lp-100 text-12px xxl:text-14px flex pl-1 gap-x-2 mt-2" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  class: "w-4.5 max-w-none",
  alt: "warning"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Close = _resolveComponent("Close")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: 
        `flex flex-row border rounded items-center w-full ${
          _ctx.error ? 'border-red-lp-100' : 'border-gray-lp-400 '
        }`
      
    }, [
      (_ctx.showViewDisabledInput)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _createVNode("div", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickInput && _ctx.onClickInput(...args))),
              class: ["rounded-l text-center px-3 focus:outline-none w-full bg-white text-gray-lp-600 cursor-not-allowed", `${_ctx.customStyle} ${_ctx.sizeProportional}`]
            }, _toDisplayString(_ctx.lengthValue), 3),
            _createVNode("div", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickInput && _ctx.onClickInput(...args)))
            }, [
              _createVNode(_component_Close, {
                class: "w-3 text-black-lp-300 cursor-not-allowed",
                style: {"opacity":"0.4"}
              })
            ]),
            _createVNode("div", {
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClickInput && _ctx.onClickInput(...args))),
              class: ["text-center px-3 focus:outline-none w-full bg-white text-gray-lp-600 cursor-not-allowed", `${_ctx.customStyle} ${_ctx.sizeProportional}`]
            }, _toDisplayString(_ctx.widthValue), 3),
            _createVNode("div", {
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onClickInput && _ctx.onClickInput(...args)))
            }, [
              _createVNode(_component_Close, {
                class: "w-3 text-black-lp-300 cursor-not-allowed",
                style: {"opacity":"0.4"}
              })
            ]),
            _createVNode("div", {
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onClickInput && _ctx.onClickInput(...args))),
              class: ["text-center px-3 focus:outline-none w-full bg-white text-gray-lp-600 cursor-not-allowed", `${_ctx.customStyle} ${_ctx.sizeProportional}`]
            }, _toDisplayString(_ctx.heightValue), 3)
          ], 64))
        : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
            _createVNode("input", {
              disabled: _ctx.disabled,
              type: "text",
              name: "length",
              onInput: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.setInput && _ctx.setInput(...args))),
              value: _ctx.lengthValue,
              placeholder: _ctx.length,
              class: ["rounded-l text-center px-3 focus:outline-none w-full", 
          `${
            _ctx.disabled
              ? 'bg-white text-gray-lp-600 cursor-not-allowed'
              : 'text-black-lp-300'
          } ${_ctx.customStyle} ${_ctx.sizeProportional}`
        ],
              maxlength: _ctx.maxLength
            }, null, 42, ["disabled", "value", "placeholder", "maxlength"]),
            _createVNode("div", null, [
              _createVNode(_component_Close, { class: "w-3 text-black-lp-300" })
            ]),
            _createVNode("input", {
              disabled: _ctx.disabled,
              type: "text",
              name: "width",
              onInput: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.setInput && _ctx.setInput(...args))),
              value: _ctx.widthValue,
              placeholder: _ctx.width,
              class: ["text-center px-3 focus:outline-none w-full", 
          `${
            _ctx.disabled
              ? 'bg-white text-gray-lp-600 cursor-not-allowed'
              : 'text-black-lp-300'
          } ${_ctx.customStyle} ${_ctx.sizeProportional}`
        ],
              maxlength: _ctx.maxLength
            }, null, 42, ["disabled", "value", "placeholder", "maxlength"]),
            _createVNode("div", null, [
              _createVNode(_component_Close, { class: "w-3 text-black-lp-300" })
            ]),
            _createVNode("input", {
              disabled: _ctx.disabled,
              name: "height",
              type: "text",
              onInput: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.setInput && _ctx.setInput(...args))),
              value: _ctx.heightValue,
              placeholder: _ctx.height,
              class: ["text-center px-3 focus:outline-none w-full", 
          `${
            _ctx.disabled
              ? 'bg-white text-gray-lp-600 cursor-not-allowed'
              : 'text-black-lp-300'
          } ${_ctx.customStyle} ${_ctx.sizeProportional}`
        ],
              maxlength: _ctx.maxLength
            }, null, 42, ["disabled", "value", "placeholder", "maxlength"])
          ], 64)),
      _hoisted_2
    ], 2),
    _withDirectives(_createVNode("div", _hoisted_3, [
      (_ctx.withIcon)
        ? (_openBlock(), _createBlock("img", _hoisted_4))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(_ctx.errorCaption), 1)
    ], 512), [
      [_vShow, _ctx.error]
    ])
  ]))
}